<div class="base-modal h-screen bg-white"
>
  <ng-content select="header"></ng-content>
  <ng-content></ng-content>
  <ng-content select="footer"></ng-content>
</div>
